import EnumDataSource from "../utils/enum-data-source.util";

export const APPOINTMENT_TYPE_GENERAL_TYPE_FITTING = "1";
export const APPOINTMENT_TYPE_GENERAL_TYPE_DIAGNOSTIC = "2";
export const APPOINTMENT_TYPE_GENERAL_TYPE_SERVICE = "3";
export const APPOINTMENT_TYPE_SCHEDULE = "4";
export const APPOINTMENT_TYPE_GENERAL_TYPE_OTHER = "99";
export const APPOINTMENT_TYPE_GENERAL_TYPE_SCHEDULER = "100";

const appointmentTypesCategories = {
  [APPOINTMENT_TYPE_GENERAL_TYPE_FITTING]: "Fitting",
  [APPOINTMENT_TYPE_GENERAL_TYPE_DIAGNOSTIC]: "Diagnostic",
  [APPOINTMENT_TYPE_GENERAL_TYPE_SERVICE]: "Service",
  [APPOINTMENT_TYPE_SCHEDULE]: "Personal or Clinic Event",
  [APPOINTMENT_TYPE_GENERAL_TYPE_OTHER]: "Other",
  [APPOINTMENT_TYPE_GENERAL_TYPE_SCHEDULER]: "Web Scheduler"
};

export const APPOINTMENT_TYPES_CATEGORIES = new EnumDataSource(
  appointmentTypesCategories
);

export const DEFAULT_APPOINTMENT_TYPE_CATEGORY = 99;

export const SAME_DAY = "same_day";
export const NEXT_DAY = "next_day";
export const FORTY_EIGHT_HOURS = "48_hours";

const AppointmentAllowBooking = {
  [SAME_DAY]: "Appointments can be booked at the first available slot",
  [NEXT_DAY]: "Appointments must be booked at least 1 day in advance",
  [FORTY_EIGHT_HOURS]: "Appointments must be booked at least 2 days in advance"
};

export const APPOINTMENTMENT_BOOKING_CONFIGURATIONS = new EnumDataSource(
  AppointmentAllowBooking
);

export const SNAP_TO_MINUTES_15 = 15;
export const SNAP_TO_MINUTES_30 = 30;
export const SNAP_TO_MINUTES_DEFAULT = String(SNAP_TO_MINUTES_15);

const snapToMinutesOptions = {
  [SNAP_TO_MINUTES_15]: "15 minutes",
  [SNAP_TO_MINUTES_30]: "30 minutes"
};

export const SNAP_TO_MINUTES_CONFIGURATIONS = new EnumDataSource(
  snapToMinutesOptions
);

export const PATIENT_VISIBILITY_NEW_ONLY = "1";
export const PATIENT_VISIBILITY_RETURNING_ONLY = "2";
export const PATIENT_VISIBILITY_BOTH = "3";

const PatientVisibilityOptions = {
  [PATIENT_VISIBILITY_NEW_ONLY]: "New Patients Only",
  [PATIENT_VISIBILITY_RETURNING_ONLY]: "Returning Patients Only",
  [PATIENT_VISIBILITY_BOTH]: "Both New & Returning"
};

export const PATIENT_VISIBILITY_CONFIGURATIONS = new EnumDataSource(
  PatientVisibilityOptions
);
